import { Route, Switch, useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import CycleMomentSelectorModal from 'packages/kakapo-ui-kit/components/cycles/CycleMomentSelectorModal';

import useAuthenticatedUser from '../../../hooks/useAuthenticatedUser';

import FeedbackRequestModal, {
	FeedbackRequestModalMoment,
} from '../request-modal/FeedbackRequestModal';
import SendFeedbackModal from './SendFeedbackModal';

export default function FeedbackRequestModals(props: { userID: string; refetch: () => void }) {
	const history = useHistory();
	const viewer = useAuthenticatedUser();

	const isViewer = viewer.id === props.userID;

	const returnURL = (() => {
		const params = new URLSearchParams(history.location.search);
		if (params.has('return') && params.get('return')?.startsWith('/')) {
			return params.get('return');
		}
		return isViewer ? '/feedback' : `/users/${props.userID}/feedback`;
	})() as string;

	return (
		<Switch>
			<Route<{ userID: string }> path={['/feedback/send', `/users/:userID/feedback/send`]} exact>
				{({ match }) => <SendFeedbackModal userID={match!.params.userID} />}
			</Route>
			<Route
				path={[
					'/feedback/request-from-moment',
					`/user/${props.userID}/feedback-v2/request-from-moment`,
				]}
				exact
			>
				<CycleMomentSelectorModal
					type={graphql.MomentType.Feedback}
					returnURL={returnURL}
					regularURL={isViewer ? '/feedback/request' : `/user/${props.userID}/feedback-v2/request`}
					momentURL={(moment) =>
						`/user/${props.userID}/feedback-v2/request-from-moment/${moment.id}`
					}
				/>
			</Route>
			<Route path={['/feedback/request', `/user/${props.userID}/feedback-v2/request`]} exact>
				<FeedbackRequestModal
					userID={props.userID}
					returnURL={returnURL}
					refresh={() => props.refetch()}
				/>
			</Route>
			<Route
				path={[
					'/feedback/request/competencies',
					`/user/${props.userID}/feedback-v2/request/competencies`,
				]}
				exact
			>
				<FeedbackRequestModal
					method="competencies"
					userID={props.userID}
					returnURL={returnURL}
					refresh={() => props.refetch()}
				/>
			</Route>
			<Route
				path={[
					`/feedback/request-from-moment/:momentID`,
					`/user/${props.userID}/feedback-v2/request-from-moment/:momentID`,
				]}
				exact
			>
				<FeedbackRequestModalMoment
					userID={props.userID}
					returnURL={returnURL}
					refresh={() => props.refetch()}
				/>
			</Route>
		</Switch>
	);
}
